<form [formGroup]="paginationForm" class="pagination-control-container">
	<div class="btns">
		<!-- Previous Page Button -->
		<button class="btn btn-default m-r-1" (click)="goPrevious()" [disabled]="paginationForm.controls['currentPageNumber'].value === 1">
			<i class="ion ion-chevron-left"></i>
		</button>

		<!-- Page Select Dropdown -->
		<!--		offset-->
		<div class="form-inline">
			<select
				class="form-control rows-per-page m-r-1"
				id="current-page"
				formControlName="currentPageNumber"
			>
				@for (page of totalNumberOfPages; track $index) {
					<option [value]="page">{{ page }}</option>
				}
			</select>
		</div>

		<!-- Next Page Button -->
<!--		offset-->
		<button class="btn btn-default m-r-1" (click)="goNext()" [disabled]="paginationForm.controls['currentPageNumber'].value === totalNumberOfPages.length">
			<i class="ion ion-chevron-right"></i>
		</button>

		<!-- Save Page Checkbox (optional) -->
		@if (savePageLocalStorageKey()) {
			<div class="pagination-save-checkbox_container">
				<input
					id="save-page"
					class="checkbox blue-checkbox"
					type="checkbox"
					formControlName="saveOnChange"
				/>
				<label class="label-save-page" for="save-page">Save page</label>
			</div>
		}
	</div>
	<!--		limit-->
	<div class="text-right">
		<div class="form-inline">
			<label for="items-per-page" style="margin-right: 8px">Rows Per Page</label>
			<select formControlName="limit" id="items-per-page" class="form-control rows-per-page m-r-1">
				@for (option of itemsPerPageOptions(); track $index) {
					<option [value]="option">{{option}}</option>
				}
			</select>
		</div>
	</div>
</form>
